import React from 'react';
import { motion } from 'framer-motion';
export function HeroSection() {
  const scrollToOffer = () => {
    const offerSection = document.getElementById('oferta');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative pt-12 pb-20 px-4 md:pt-20 md:pb-28 overflow-hidden bg-gradient-to-b from-[#FFF8F0] to-[#FFE0B2]/30" data-id="element-411">
      <div className="max-w-lg md:max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-412">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-413">
          <span className="inline-block py-1 px-3 rounded-full bg-[#E8F5E9] text-[#2E7D32] text-sm font-bold mb-6 tracking-wide" data-id="element-414">
            🥦 NUTRIPEQUES
          </span>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black text-gray-900 leading-tight mb-6 text-balance" data-id="element-415">
            "Tu hijo no rechaza la comida. Rechaza el caos. Y esto lo soluciona
            en <span className="text-[#FF8A65]" data-id="element-416">30 minutos por semana</span>."
          </h1>
          <p className="text-lg md:text-2xl text-gray-700 mb-10 font-medium" data-id="element-417">
            Guía práctica de alimentación infantil sin estrés
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="w-full max-w-md mx-auto mb-10 relative" data-id="element-418">
          <div className="absolute inset-0 bg-[#4CAF50]/20 blur-3xl rounded-full transform -translate-y-4" data-id="element-419"></div>
          <img src="https://cdn.magicpatterns.com/uploads/wkzGFuHWyP7z23EbiJvcUP/heylloyd-image-1772533088855.png" alt="NutriPeques Guía Práctica" className="w-full h-auto relative z-10 drop-shadow-2xl rounded-2xl" data-id="element-420" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="w-full max-w-md" data-id="element-421">
          <button onClick={scrollToOffer} className="w-full min-h-[64px] bg-[#2E7D32] hover:bg-[#1B5E20] text-white text-xl font-bold rounded-2xl shadow-[0_8px_0_#1B5E20] hover:shadow-[0_4px_0_#1B5E20] hover:translate-y-1 transition-all flex items-center justify-center gap-2 px-6" data-id="element-422">
            → Quiero nutrir con calma
          </button>
          <p className="text-sm text-gray-500 mt-6 flex items-center justify-center gap-2" data-id="element-423">
            <span className="flex items-center" data-id="element-424">⭐⭐⭐⭐⭐</span>
            <span data-id="element-425">+2,500 mamás ya lo usan</span>
          </p>
        </motion.div>
      </div>
    </section>;
}